import { useState } from 'react';
import { Trans, useTranslation } from "react-i18next";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import { Button, Container } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


function LanguageButton() {

  const { t, i18n } = useTranslation();

  const [lang, setLang] = useState("IT")

  const handleChange = (event) => {
    switch (lang) {
      case "IT":
        setLang("DE");
        i18n.changeLanguage("it");
        break;
      default:
        setLang("IT")
        i18n.changeLanguage("de");
    }
  };

  return (
    <>
      <Button variant="contained" disableElevation onClick={handleChange}>{lang}</Button>
    </>
  );
}

export default LanguageButton;
